<section class="card mb-0" *ngIf="isProperty">
  <div class="card-body" [formGroup]="summaryForm">
    <div class="row g-3">
      <div class="col-lg-4">
        <label class="form-label" for="cmiContractNumber">{{ "t-contract-number" | translate }}</label>
        <input id="cmiContractNumber" class="form-control" type="text" formControlName="contractNumber"
          [ngClass]="{ 'is-warning': hasWarning('contractNumber') }"
          placeholder="{{ 't-contract-number' | translate }}" />
      </div>

      <div class="col-lg-4">
        <label class="form-label" for="cmiStartDate">{{ "t-m-properties.t-start-date" | translate }}</label>
        <input id="cmiStartDate" class="form-control flatpickr-input" type="text" mwlFlatpickr
          [convertModelValue]="false" [monthSelectorType]="'static'" [dateFormat]="'Y-m-d'"
          formControlName="startDateMediation" (flatpickrChange)="onDurationChange()"
          [ngClass]="{ 'is-warning': hasWarning('startDateMediation') }"
          placeholder="{{ 't-general.t-select' | translate }}" />
      </div>

      <div class="col-lg-4">
        <label class="form-label" for="cmiDuration">{{ "t-m-properties.t-define-end-date" | translate }}</label>
        <ng-select id="cmiDuration" [items]="durationOptions" [multiple]="false" formControlName="defineEndDate"
          (change)="onDurationChange()" placeholder="{{ 't-general.t-select' | translate }}">
          <ng-template ng-label-tmp let-item="item">
            {{ item }} {{ "t-cmi-templates.runtime.months" | translate }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item }} {{ "t-cmi-templates.runtime.months" | translate }}
          </ng-template>
        </ng-select>
      </div>

      <div class="col-lg-4">
        <label class="form-label" for="cmiEndDate">{{ "t-m-properties.t-end-date" | translate }}</label>
        <input id="cmiEndDate" class="form-control flatpickr-input" type="text" mwlFlatpickr
          [convertModelValue]="false" [monthSelectorType]="'static'" [dateFormat]="'Y-m-d'"
          formControlName="endDateMediation" [attr.readonly]="endDateLocked ? '' : null"
          [attr.style]="endDateLocked ? 'background-color:#eff2f7;cursor:auto;' : null"
          [ngClass]="{ 'is-warning': hasWarning('endDateMediation') }"
          placeholder="{{ 't-general.t-select' | translate }}" />
      </div>

      <!-- <div class="col-lg-4 d-flex align-items-end">
        <div class="form-check form-switch mb-2">
          <input class="form-check-input" type="checkbox" id="cmiAutoRenewal" formControlName="autoRenewal" />
          <label class="form-check-label" for="cmiAutoRenewal">
            {{ "t-cmi-templates.runtime.auto-renewal" | translate }}
          </label>
        </div>
      </div> -->
    </div>

    <!--
      "CMI gerados": sem template publicado (ou sem a permissão CAN_GENERATE_CMI)
      e sem documentos antigos, o bloco não aparece — a mensagem "sem template"
      só confundia quem nunca vai usar o CMI. Com documentos antigos a tabela
      mantém-se (histórico), sem o botão de gerar.
    -->
    <ng-container *ngIf="loadingAvailability || canGenerate || documents.length > 0 || showSavePropertyFirst">
    <hr class="my-4" />

    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
      <h6 class="mb-0">{{ "t-cmi-templates.runtime.generated-title" | translate }}</h6>
      <div class="d-flex align-items-center gap-2">
        <span class="spinner-border spinner-border-sm text-primary" *ngIf="loadingAvailability"></span>
        <button *ngIf="canGenerate" type="button" class="btn btn-primary btn-sm"
          [disabled]="loadingSchema" (click)="openGenerator()">
          <i class="ri-file-add-line me-1"></i>
          {{ (loadingSchema ? "t-cmi-templates.runtime.loading" : "t-cmi-templates.runtime.generate") | translate }}
        </button>
      </div>
    </div>

    <div class="alert alert-light border mb-0" *ngIf="!loadingAvailability && !hasContext">
      {{ "t-cmi-templates.runtime.save-property-first" | translate }}
    </div>

    <div class="alert alert-light border mb-0" *ngIf="!loadingAvailability && canGenerate && documents.length === 0">
      {{ "t-cmi-templates.runtime.no-documents" | translate }}
    </div>

    <div class="table-responsive" *ngIf="documents.length > 0">
      <table class="table table-sm table-hover align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th>{{ "t-cmi-templates.runtime.document" | translate }}</th>
            <th>{{ "t-cmi-templates.runtime.generated-at" | translate }}</th>
            <th class="text-end">{{ "t-cmi-templates.actions" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let document of documents; trackBy: trackDocument">
            <td>{{ document.fileName }}</td>
            <td>{{ document.createdAt | date: "short" }}</td>
            <td class="text-end">
              <button type="button" class="btn btn-soft-secondary btn-sm" (click)="downloadDocument(document)">
                <i class="ri-download-2-line me-1"></i>{{ "t-cmi-templates.download" | translate }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    </ng-container>
  </div>
</section>

<ng-template #mediationContractModal let-modal>
  <div class="modal-header">
    <div>
      <h5 class="modal-title">{{ "t-cmi-templates.runtime.title" | translate }}</h5>
      <small class="text-muted" *ngIf="schema">
        {{ "t-cmi-templates.runtime.template-version" | translate: { version: schema.templateVersionId } }}
      </small>
    </div>
    <button type="button" class="btn-close" [attr.aria-label]="'t-cmi-templates.close' | translate" (click)="modal.dismiss('close')"></button>
  </div>
  <div class="modal-body p-0">
    <ng-container *ngTemplateOutlet="dynamicFormContent"></ng-container>
  </div>
</ng-template>

<ng-template #dynamicFormContent>
  <div class="cmi-runtime-loading" *ngIf="loadingSchema">
    <span class="spinner-border text-primary" role="status"></span>
    <span class="text-muted mt-3">{{ "t-cmi-templates.runtime.loading" | translate }}</span>
  </div>

  <div class="cmi-runtime-empty" *ngIf="!loadingSchema && schemaLoadFailed">
    <i class="ri-error-warning-line"></i>
    <p>{{ "t-cmi-templates.runtime.errors.schema-load" | translate }}</p>
    <button type="button" class="btn btn-soft-primary btn-sm" (click)="loadSchema()">
      {{ "t-cmi-templates.reload" | translate }}
    </button>
  </div>

  <div class="cmi-runtime-empty" *ngIf="!loadingSchema && !schemaLoadFailed && groups.length === 0">
    <i class="ri-file-list-3-line"></i>
    <p>{{ "t-cmi-templates.runtime.empty" | translate }}</p>
  </div>

  <form
    *ngIf="!loadingSchema && !schemaLoadFailed && groups.length > 0"
    class="cmi-runtime-form"
    [formGroup]="dynamicForm"
    (ngSubmit)="submitContract()"
  >
    <ngb-accordion class="cmi-runtime-accordion" [closeOthers]="false" [activeIds]="activePanelIds">
      <ngb-panel *ngFor="let group of groups; trackBy: trackGroup" [id]="group.panelId">
        <!-- ngbPanelHeader (e não ngbPanelTitle) é o único que recebe `opened`,
             necessário para orientar a seta. -->
        <ng-template ngbPanelHeader let-panel let-opened="opened">
          <button type="button" class="cmi-panel-toggle" [ngbPanelToggle]="panel"
            [attr.aria-expanded]="opened">
            <span class="cmi-panel-title">
              <i class="ri-arrow-right-s-line cmi-panel-chevron" [class.is-open]="opened"></i>
              <span class="fw-semibold">{{ group.labelKey | translate }}</span>
            </span>
            <span class="cmi-panel-count"
              [class.is-complete]="filledCount(group) === group.fields.length">
              {{ filledCount(group) }}/{{ group.fields.length }}
            </span>
          </button>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="row g-3">
            <div class="col-12" *ngFor="let field of group.fields; trackBy: trackField" [class.col-lg-6]="!field.multiline && field.valueType !== 'CHECKBOX'">
              <label class="form-label" [for]="field.controlName" *ngIf="field.valueType !== 'CHECKBOX'">
                {{ field.labelKey | translate }}
                <span class="text-danger" *ngIf="field.required">*</span>
              </label>

              <ng-select
                appendTo="body"
                *ngIf="field.options && field.options.length > 0"
                [id]="field.controlName"
                [items]="field.options"
                bindValue="value"
                [clearable]="!field.required"
                [formControlName]="field.controlName"
                [placeholder]="'t-cmi-templates.runtime.select-placeholder' | translate"
              >
                <ng-template ng-label-tmp let-item="item">{{ item.labelKey ? (item.labelKey | translate) : (item.label || item.displayValue) }}</ng-template>
                <ng-template ng-option-tmp let-item="item">{{ item.labelKey ? (item.labelKey | translate) : (item.label || item.displayValue) }}</ng-template>
              </ng-select>

              <textarea
                *ngIf="(!field.options || field.options.length === 0) && field.multiline"
                class="form-control"
                rows="4"
                [id]="field.controlName"
                [attr.maxlength]="field.maxCharacters || null"
                [formControlName]="field.controlName"
              ></textarea>

              <div class="form-check form-switch mt-2" *ngIf="(!field.options || field.options.length === 0) && field.valueType === 'CHECKBOX'">
                <input class="form-check-input" type="checkbox" [id]="field.controlName" [formControlName]="field.controlName" />
                <label class="form-check-label" [for]="field.controlName">
                  {{ field.labelKey | translate }}
                  <span class="text-danger" *ngIf="field.required">*</span>
                </label>
              </div>

              <input
                *ngIf="(!field.options || field.options.length === 0) && !field.multiline && field.valueType === 'DATE'"
                class="form-control"
                type="date"
                [id]="field.controlName"
                [formControlName]="field.controlName"
              />

              <input
                *ngIf="(!field.options || field.options.length === 0) && !field.multiline && (field.valueType === 'CURRENCY' || field.valueType === 'PERCENTAGE')"
                class="form-control"
                type="number"
                step="0.01"
                [id]="field.controlName"
                [formControlName]="field.controlName"
              />

              <input
                *ngIf="(!field.options || field.options.length === 0) && !field.multiline && field.valueType === 'TEXT'"
                class="form-control"
                type="text"
                [id]="field.controlName"
                [attr.maxlength]="field.maxCharacters || null"
                [formControlName]="field.controlName"
              />

              <div class="invalid-feedback d-block" *ngIf="isInvalid(field)">
                {{ "t-cmi-templates.runtime.required" | translate }}
              </div>
            </div>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>

    <div class="cmi-runtime-actions">
      <button type="button" class="btn btn-light" *ngIf="!isProperty" [disabled]="spinnerLoading" (click)="closeModal()">
        {{ "t-cmi-templates.cancel" | translate }}
      </button>
      <button type="submit" class="btn btn-primary" [disabled]="spinnerLoading">
        <span class="spinner-border spinner-border-sm me-2" role="status" *ngIf="spinnerLoading"></span>
        {{ (spinnerLoading ? "t-cmi-templates.runtime.generating" : "t-cmi-templates.runtime.generate") | translate }}
      </button>
    </div>
  </form>
</ng-template>
